/**
 * @flow
 * @relayHash 3f2a0476f785f300f1c536f0a06b52dc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWarehouseLocationInput = {|
  id: string,
  name?: ?string,
  code?: ?string,
  description?: ?string,
  isActive?: ?boolean,
|};
export type UpdateWarehouseLocationMutationVariables = {|
  input: UpdateWarehouseLocationInput
|};
export type UpdateWarehouseLocationMutationResponse = {|
  +updateWarehouseLocation: {|
    +warehouseLocationEdge: {|
      +cursor: string,
      +node: {|
        +id: string,
        +name: string,
        +code: ?string,
        +description: ?string,
        +isActive: boolean,
        +updatedAt: ?any,
        +createdAt: ?any,
      |},
    |}
  |}
|};
export type UpdateWarehouseLocationMutation = {|
  variables: UpdateWarehouseLocationMutationVariables,
  response: UpdateWarehouseLocationMutationResponse,
|};
*/


/*
mutation UpdateWarehouseLocationMutation(
  $input: UpdateWarehouseLocationInput!
) {
  updateWarehouseLocation(input: $input) {
    warehouseLocationEdge {
      cursor
      node {
        id
        name
        code
        description
        isActive
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWarehouseLocationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateWarehouseLocation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateWarehouseLocationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "warehouseLocationEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "WarehouseLocationEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isActive",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateWarehouseLocationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateWarehouseLocationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateWarehouseLocationMutation",
    "id": null,
    "text": "mutation UpdateWarehouseLocationMutation(\n  $input: UpdateWarehouseLocationInput!\n) {\n  updateWarehouseLocation(input: $input) {\n    warehouseLocationEdge {\n      cursor\n      node {\n        id\n        name\n        code\n        description\n        isActive\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1dd6cd6164f72d24a198d1b200a744a5';
module.exports = node;
